import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAuthToken } from '../utils/auth';
import { fetchProfile, logout } from '../reducers/user';
import { RootState } from '../store';

const AuthGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const dispatch = useDispatch();
  const profile = useSelector((s: RootState) => s.user.profile);
  const [rehydrating, setRehydrating] = useState(false);

  const token = getAuthToken();

  // When we have a token but no profile (e.g. after refresh), fetch profile so session persists
  useEffect(() => {
    if (!token || profile !== null || rehydrating) return;
    setRehydrating(true);
    dispatch(fetchProfile())
      .unwrap()
      .catch(() => {
        dispatch(logout());
      })
      .finally(() => {
        setRehydrating(false);
      });
  }, [token, profile, rehydrating, dispatch]);

  if (!token) {
    return <Navigate to="/login" replace />;
  }
  if (profile === null) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        Loading…
      </div>
    );
  }
  return <>{children}</>;
};

export default AuthGuard;
